module.exports = __webpack_public_path__ + "img/l-cb6-100.735f2c06.gif";